'use client';

import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import { Icon, Typography } from '@/components/core';

import styles from './Accordion.module.scss';

type AccordionProps = {
    id?: string;
    title: string | React.ReactNode;
    children: React.ReactNode;
    className?: string;
    isOpen?: boolean;
    onClose?: Function;
    controlled?: boolean;
    icon?: React.ReactNode;
};

export const Accordion: React.FC<AccordionProps> = ({
    id,
    title,
    children,
    className,
    isOpen = false,
    onClose,
    controlled,
    icon,
}) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    return (
        <div
            id={id}
            className={clsx(styles.root, className)}
        >
            <div
                className={clsx(styles.header)}
                onClick={() => {
                    if (open) {
                        onClose?.();
                    }
                    if (!controlled) {
                        setOpen(state => !state);
                    }
                }}
            >
                {typeof title === 'string' ? <Typography className="bold">{title}</Typography> : title}
                {icon ?? (
                    <Icon
                        name="arrow-up"
                        className={clsx(styles.icon, { [styles.closed]: !open })}
                    />
                )}
            </div>

            <div className={clsx(styles.contentWrapper, { [styles.active]: open })}>
                <div className={styles.content}>
                    <div className={styles.innerContent}>{children}</div>
                </div>
            </div>
        </div>
    );
};
